import moment from "moment";

export function getNow() {
  const today = new Date();
  const date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  const time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  const dateTime = date + " " + time;
  return dateTime;
}

export function getNowYearMonth() {
  const date = new Date();
  const yearOfDate = date.getFullYear();
  const monthOfDate = date.getMonth() + 1;
  const DayOfDate = date.getDate();

  return yearOfDate + "-" + monthOfDate + "-" + DayOfDate;
}

export function Script_checkID(id) {
  if (id.substring(0, 1) == 0) return false;
  if (id.length != 13) return false;
  let i = 0;
  let sum = 0;
  for (i = 0, sum = 0; i < 12; i++) sum += parseFloat(id.charAt(i)) * (13 - i);
  if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;
  return true;
}

export function getdateformat(date) {
  if (date) {
    if (date.length == 10) {
      return moment(date).locale("th").add(543, "year").format("ll");
    } else {
      return date;
    }
  } else {
    return "-";
  }
}

export function getdateformatfull(date) {
  if (date) {
    return moment(date).locale("th").add(543, "year").format("lll");
  } else {
    return "-";
  }
}

export function pad(width, string, padding) {
  return width <= string.length
    ? string
    : pad(width, padding + string, padding);
}

export function displayToast(msg, status) {
  return this.$bvToast.toast(msg, {
    title: status ? `Success` : "Fail",
    variant: status ? "success" : "danger",
    solid: status,
  });
}

export function displayMsgBox(msg, status) {
  return this.$bvModal.msgBoxOk(msg, {
    title: "แจ้งผล",
    size: "sm",
    buttonSize: "md",
    okVariant: status ? "success" : "danger",
    okTitle: "รับทราบ",
    headerClass: "p-2 border-bottom-0",
    footerClass: "p-2 border-top-0",
    centered: true,
  });
}

export function modalOKDisplay(msg, title) {
  return this.$bvModal.msgBoxOk(msg, {
    title: title,
    size: "sm",
    buttonSize: "md",
    okVariant: "success",
    okTitle: "รับทราบ",
    headerClass: "p-2 border-bottom-0",
    footerClass: "p-2 border-top-0",
    centered: true,
  });
}

export function modalConfirmDisplay(msg, title) {
  return this.$bvModal.msgBoxConfirm(msg, {
    title: title,
    size: "md",
    buttonSize: "md",
    okVariant: "danger",
    okTitle: "ยืนยัน",
    cancelTitle: "ยกเลิก",
    footerClass: "p-2",
    hideHeaderClose: false,
    centered: true,
  });
}

export function displayQueueStatus(status) {
  switch (status) {
    case "N":
      status = "รอดำเนินการ";
      break;
    case "P":
      status = "Confirm แล้ว";
      break;
    case "S":
      status = "ดำเนินการแล้ว";
      break;
    case "NC":
      status = "ผู้ประกอบการไม่มาตามนัดหมาย";
      break;
    case "C":
      status = "ยกเลิก";
      break;
  }

  return status;
}
